<script setup lang="ts">
import { BlockCarouselWide } from '~/lib/services/content/content.blocks.dtos'

const props = defineProps<{ block: BlockCarouselWide }>()

const autoplayConfig = computed(() => {
  if (!props.block.autoplay) return undefined
  return {
    delay: props.block.autoplayDelaySeconds * 1000,
    disableOnInteraction: true,
  }
})
</script>

<template>
  <div class="p-4 md:px-14 md:py-10">
    <Swiper
      class="swiper-theme-white mx-auto h-fit max-h-[520px] max-w-[1200px] rounded-lg"
      :modules="[SwiperAutoplay, SwiperEffectCreative, SwiperPagination]"
      :slides-per-view="1"
      :loop="true"
      :effect="'creative'"
      :autoplay="autoplayConfig || false"
      :auto-height="true"
      :pagination="{
        type: 'bullets',
        clickable: true,
      }"
      :creative-effect="{
        prev: {
          shadow: false,
          translate: ['-20%', 0, -1],
        },
        next: {
          translate: ['100%', 0, 0],
        },
      }"
    >
      <SwiperSlide v-for="(slide, i) in block.slides" :key="`${slide.slideTitle}${i}`">
        <CarouselItemWide :slide="slide" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style scoped>
.swiper-theme-white {
  --swiper-theme-color: #fff;
}
</style>
